import Banner from "../components/Banner";
import CoinTable from "../components/CoinTable";

function Home() {
  return (
    <>
      <Banner />
      <CoinTable />
    </>
  );
}

export default Home;
